var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('menu-options-item',{attrs:{"close":"","label":"Abrir"},on:{"click":function($event){return _vm.$emit('abrir')}}}),_c('menu-options-item',{attrs:{"close":"","label":"Excluir","label-class":"text-negative"},on:{"click":function($event){return _vm.$emit('excluir')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }